import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import * as actions from "./../../actions";

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Fade from '@material-ui/core/Fade';

const styles = theme => ({
  root:{


    zIndex: 3000,


  },
  progress: {
    margin: "auto",
  },
  wrapper:{
    display: "flex",
    flexDirection:"column",
    justifyContent:"center",
    alignContent:"center",
  },
  logo:{
    display:"block",
    position:"relative",

    animationName: "spin",
    animationDuration: "5000ms",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear",
  },

  '@keyframes spin': {
    from: {transform:"rotate(0deg)"},
    to: {transform:"rotate(360deg)"}
  }
});

class CookieConsent extends React.Component  {
  constructor(props){
    super(props)

    this.state = {
      isActive: this.props.cookies.get("cookie_consent") === undefined ? true : false
    }
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
    classes: PropTypes.object.isRequired,
  };

  consent = (event)=>{
    this.props.cookies.set("cookie_consent", event, {path: "/", maxAge: 60*60*24*365*5})
    this.setState({isActive: false})
    window.location.reload()
  }

  render(){

      return (

          <Snackbar
            anchorOrigin={{vertical: "bottom",horizontal: "right" }}
            open={this.state.isActive}

            TransitionComponent={Fade}
            ContentProps={{
              'aria-describedby': 'message-id',
            }}
            message={
              <span id="message-id">STRINJAM SE Z UPORABO PIŠKOTKOV! <br/> Spletna stran za svoje delovanje in analizo prometa uporablja piškotke!  <br/> <span style={{color:"blue", cursor: "pointer"}} onClick={()=>this.props.showCookiesInfo(true)}>Več o piškotkih</span></span>
            }
            action={[

              <Button key={1} variant="contained" color="secondary" onClick={()=>this.consent(true)}>Da</Button>,
              <Button key={2} onClick={()=>this.consent(false)}>Ne</Button>,

            ]}
          >

          </Snackbar>

      );
  }

};

const mapStateToProps = ({ cookiesInfoDialog }) => {
  return {
    cookiesInfoDialog
  }
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withCookies(CookieConsent)));



// WEBPACK FOOTER //
// ./src/components/reusableComponents/CookieConsent.js